import script from "./B2BBankTransferPaymentTile.vue?vue&type=script&setup=true&lang=ts"
export * from "./B2BBankTransferPaymentTile.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__